import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import logo from "../assets/id-tfja-h-white.webp";
import logoIustitia from "../assets/ius-logo-prec@2x.png";

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: "#f7fafc",
  padding: 0,
}));

export const Header = styled(Box)(({ theme }) => ({
  backgroundColor: "#8a8f95",
  padding: theme.spacing(2),
  textAlign: "center",
  color: "white",
}));

export const Main = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

export const Footer = styled(Box)(({ theme }) => ({
  backgroundColor: "#8a8f95",
  color: "white",
  padding: theme.spacing(2),
  textAlign: "center",
}));

export const FormWrapper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  width: "560px",
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
}));

export const CommonLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <StyledContainer>
    <Header>
      <img src={logo} alt="Government Seal" style={{ width: "400px", height: "auto" }} />
    </Header>
    <Box display="flex" alignItems="center" justifyContent="center" sx={{ py: 4, backgroundColor: "#f7fafc" }}>
      <img src={logoIustitia} alt="Logo Iustitia" style={{ width: "200px", height: "auto" }} />
    </Box>
    <Main>
      {children}
    </Main>
    <Footer>
      <Typography variant="body2">TFJA 2024 | Xertica.ai</Typography>
      <Typography variant="body2">Versión: 1.0</Typography>
    </Footer>
  </StyledContainer>
);
